import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import MultipleCloudUserFormatter from '../../../shared/columns/formatters/MultipleCloudUserFormatter';

class ClarksonsBrokerRenderer extends Component {
    constructor(props) {
        super(props);
        this.elRef = React.createRef();
    }

    tooltipDelay = 400;

    clearTooltipTimer = () => {
        if (!this.tooltipTimer) {
            return;
        }
        window.clearTimeout(this.tooltipTimer);
        this.tooltipTimer = undefined;
    };

    render() {
        const { node, value } = this.props;

        let displayValue;

        if (node && node.group) {
            displayValue = null;
        } else if (node && value) {
            displayValue = (
                <MultipleCloudUserFormatter node={node} value={value} />
            );
        }

        return (
            <div
                ref={this.elRef}
                style={{
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                }}
                data-tip={`${this.props.rowIndex}`}
                data-for={`${this.props.context.gridId}-clarksons-broker`}
                onMouseEnter={() => {
                    if (this.tooltipTimer) {
                        return; // prevent double triggering problem on some browsers
                    }

                    this.tooltipTimer = setTimeout(() => {
                        ReactTooltip.show(this.elRef.current);
                        this.clearTooltipTimer();
                    }, this.tooltipDelay);
                }}
                onMouseLeave={() => {
                    this.clearTooltipTimer();
                    ReactTooltip.hide(this.elRef.current);
                }}
            >
                {displayValue}
            </div>
        );
    }
}

export default ClarksonsBrokerRenderer;
